import { ref } from "vue";

const isOpen = ref(false);
let resolver: (() => void) | null = null;

export const groupSelectDialogOpen = isOpen;

export function showGroupSelectDialog(): Promise<void> {
  return new Promise<void>((resolve) => {
    resolver = resolve;
    isOpen.value = true;
  });
}

export function confirmGroupSelectDialog(): void {
  isOpen.value = false;
  const r = resolver;
  resolver = null;
  r?.();
}
